import { useAuth } from "@/contexts/AuthContext";
import type { ReactNode } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { LoadingState } from "./ui/states";

/** Protege rotas autenticadas: mostra loading, redireciona ao login ou renderiza. */
export function ProtectedRoute({ children }: { children: ReactNode }) {
  const { status } = useAuth();
  const location = useLocation();

  if (status === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center">
        <LoadingState label="Carregando sua sessão…" />
      </div>
    );
  }

  if (status === "unauthenticated") {
    return (
      <Navigate to="/login" replace state={{ from: `${location.pathname}${location.search}` }} />
    );
  }

  return <>{children}</>;
}
